import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { inWords, calcChallanNetRate } from "../../utils";
import _ from "lodash";
import { baseUrl } from '../../config/api';


// THIS IS THE MAIN CHALLAN TEMPLATE

export const challan2Template = (data) => {
    return new Promise((resolve) => {
        const {
            qrCode,
            clientName,
            clientAddress,
            challanDate,
            items,
            ad,
            challanCode,
            entityName,
            entityId,
            packagingCost,
            runningChallanBalance,
            createdAt,
            qr,
            hideRate = false
        } = data;

        let code = "";
        if (entityId === "62da46cf7eb6aa02db41297f") {
            code = `VO`;
        } else if (entityId === "62da46c57eb6aa02db41297d") {
            code = `IE`;
        } else {
            code = `Astra Lenses Eyecare`;
        }

        let totalAmount = 0;
        let totalQuantity = 0;
        let rows = [];

        items.forEach((item, index) => {
            const {
                lProductCode, rProductCode, nameR, nameL,
                quantity, amount, rateR, rateL,
                discountPercent, discountAmount,
                fitting, fittingAmount, tint, arc, orderRef
            } = item;

            totalAmount += Number(amount);
            totalQuantity += Number(quantity);

            if (hideRate) {
                rows.push([
                    index + 1,
                    `${nameR ? `R/${nameR}` : ''} ${rProductCode ? "[" + rProductCode.substring(3) + "]" : ""} \n${nameL ? `L/${nameL}` : ''} ${lProductCode ? "[" + lProductCode.substring(3) + "]" : ""}${orderRef ? "\nOrd Ref: " + orderRef : ""}`,
                    quantity,
                ]);
            } else {
                // Display discount info (percent or amount)
                let discountDisplay = '';
                if (discountPercent && discountPercent > 0) {
                    discountDisplay = `${discountPercent}%`;
                } else if (discountAmount && discountAmount > 0) {
                    discountDisplay = String(_.round(discountAmount, 2));
                }
                
                rows.push([
                    index + 1,
                    `${nameR ? `R/${nameR}` : ''} ${rProductCode ? "[" + rProductCode.substring(3) + "]" : ""} \n${nameL ? `L/${nameL}` : ''} ${lProductCode ? "[" + lProductCode.substring(3) + "]" : ""}${orderRef ? "\nOrd Ref: " + orderRef : ""}`,
                    quantity,
                    `${rateR || ''}\n${rateL || ''}`,
                    discountDisplay,
                    calcChallanNetRate(item),
                    `${fitting ? `Fitt:${fitting}-${fittingAmount}` : ''}\n${tint ? `tint:${tint}` : ''}\n${arc ? `ARC:${arc}` : ''}`,
                    _.round(amount, 2).toFixed(2)
                ]);
            }
        });

        const totalAmountInWords = inWords(_.round(totalAmount + Number(packagingCost), 2));
        const finalAmount = _.round(Number(packagingCost) + totalAmount, 2).toFixed(2);

        const doc = new jsPDF();

        // Header count must match body row length (8 cols when rates shown).
        const headers = hideRate
            ? [['#', 'Name', 'Qty']]
            : [['#', 'Name', 'Qty', 'Rate', 'Discount', 'Net Rate', 'Extra Charges', 'Amount']];
        doc.setFontSize(10);

        const columnStyles = hideRate
            ? {
                0: { cellWidth: 10 },
            }
            : {
                0: { cellWidth: 10 },
                4: { cellWidth: 18 }, // Discount
                5: { cellWidth: 18 }, // Net Rate
                6: { cellWidth: 35 }, // Extra Charges
                7: { halign: 'right' }, // Amount
            };

        // Calculate startY based on whether address is displayed
        const addressHeight = (clientAddress && clientAddress.trim() !== '') 
            ? (doc.splitTextToSize(clientAddress, 180).length * 4) + 3 
            : 0;
        const tableStartY = 22 + addressHeight;
        
        doc.autoTable({
            head: headers,
            margin: { left: 2, right: 2, top: 2 },
            body: rows,
            startY: tableStartY, // Adjusted to accommodate party name and address
            styles: {
                fontSize: 10,
                cellPadding: 2,
                textColor: [0, 0, 0],
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
                fillColor: [255, 255, 255]
            },
            headStyles: {
                fontStyle: 'bold',
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                fontSize: 8,
            },
            columnStyles: columnStyles,
            didDrawPage: function (data) {
                if (data.pageCount === 1) {
                    doc.setFontSize(13);
                    doc.text(`Approval Memo`, 10, 10);
                    doc.text(`${code}`, 100, 10, { align: 'center' });
                    doc.text(`Dt: ${createdAt}`, 200, 10, { align: 'right' });
                    
                    // Party name with larger font size and on separate line
                    doc.setFontSize(12);
                    doc.setFont(undefined, 'bold');
                    doc.text(`M / S: ${clientName}`, 10, 15);
                    
                    // Address below party name (if available) - make it bold
                    let addressY = 20;
                    if (clientAddress && clientAddress.trim() !== '') {
                        doc.setFontSize(9);
                        doc.setFont(undefined, 'bold');
                        const addressLines = doc.splitTextToSize(clientAddress, 180);
                        addressLines.forEach((line) => {
                            doc.text(line, 10, addressY, { fontStyle: 'bold' });
                            addressY += 4;
                        });
                    }
                    
                    // Challan code on separate line to prevent merging
                    doc.setFontSize(10);
                    doc.setFont(undefined, 'normal');
                    doc.text(`${challanCode}`, 200, 15, { align: 'right' });
                }

                // Footer
                let footerStr = `Page ${data.pageCount}`;
                doc.text(footerStr, data.settings.margin.left, doc.internal.pageSize.height - 10);
            }
        });

        const mainTable = doc.lastAutoTable;
        const secondTableStartY = mainTable.finalY;
        const pageWidth =
            (typeof doc.internal.pageSize.getWidth === 'function' && doc.internal.pageSize.getWidth()) ||
            doc.internal.pageSize.width;
        const totalsTableWidth =
            mainTable && typeof mainTable.getWidth === 'function'
                ? mainTable.getWidth(pageWidth)
                : pageWidth - 4;

        const cols = mainTable?.columns || [];
        const tableMarginLeft = 2;
        const colStart = (index) =>
            tableMarginLeft + cols.slice(0, index).reduce((sum, col) => sum + (col.width || 0), 0);
        const colEnd = (index) => colStart(index) + (cols[index]?.width || 0);
        const amountColIndex = hideRate ? 2 : 7;
        const qtyColIndex = 2;

        let footerY = secondTableStartY + 5;
        const footerLineHeight = 7;
        doc.setFont(undefined, 'bold');
        doc.setFontSize(11);

        const drawFooterLine = (label, qtyText, amountText) => {
            doc.text(label, colStart(0) + 1, footerY);
            if (qtyText) {
                doc.text(qtyText, colStart(qtyColIndex) + 1, footerY);
            }
            if (amountText != null && amountText !== '') {
                doc.text(String(amountText), colEnd(amountColIndex) - 1, footerY, { align: 'right' });
            }
            footerY += footerLineHeight;
        };

        if (hideRate) {
            drawFooterLine(`Total Qty: ${totalQuantity}`, null, null);
            if (runningChallanBalance !== null && runningChallanBalance !== undefined) {
                drawFooterLine('Running Challan Balance', null, runningChallanBalance);
            }
        } else {
            drawFooterLine('Sub Total', `Total Qt: ${totalQuantity}`, _.round(totalAmount).toFixed(2));
            drawFooterLine('Packaging Cost', null, _.round(Number(packagingCost), 2).toFixed(2));
            drawFooterLine('Total Amount', null, finalAmount);
            if (runningChallanBalance !== null && runningChallanBalance !== undefined) {
                drawFooterLine('Running Challan Balance', null, runningChallanBalance);
            }
        }

        let noteY = footerY + 4;
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        if (!hideRate) {
            const inWordsLines = doc.splitTextToSize(
                `In Words: ${totalAmountInWords}`,
                totalsTableWidth - 10
            );
            inWordsLines.forEach((line) => {
                doc.text(line, 15, noteY);
                noteY += 5;
            });
            noteY += 2;
        }
        doc.text('E & OE', 15, noteY);
        noteY += 5;
        doc.text('Working Hours: 10.30 AM to 7.00 PM', 15, noteY);
        noteY += 5;

        // Display print ads at the bottom (if available)
        if (ad && ad.trim() !== '') {
            const pageWidth = doc.internal.pageSize.getWidth();
            const leftMargin = 15;
            const rightMargin = 15;
            const maxTextWidth = pageWidth - leftMargin - rightMargin;
            const adText = ad.trim();
            const splitAdText = doc.splitTextToSize(adText, maxTextWidth);
            
            let adY = noteY + 3;
            splitAdText.forEach((line) => {
                doc.text(line, leftMargin, adY, { halign: 'left', fontStyle: 'normal' });
                adY += 4;
            });
        }

        const getBlobAndResolve = () => {
            const pdfBlob = doc.output('blob');
            resolve(pdfBlob);
        };

        if (qr && qrCode && qrCode.trim() !== '') {
            const qrCodeUrl = `${baseUrl}${qrCode}`;
            console.log('Loading QR code from:', qrCodeUrl);
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.src = qrCodeUrl;

            img.onload = () => {
                try {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0);
                    const qrBase64 = canvas.toDataURL("image/png");

                    // Get total number of pages and set to last page
                    const totalPages = doc.internal.getNumberOfPages();
                    doc.setPage(totalPages);

                    const pageWidth = doc.internal.pageSize.getWidth();
                    const pageHeight = doc.internal.pageSize.getHeight();
                    const qrSize = 40;
                    const margin = 10;
                    const x = pageWidth - qrSize - margin;
                    const y = pageHeight - qrSize - margin;

                    doc.addImage(qrBase64, "PNG", x, y, qrSize, qrSize);
                    console.log(`QR code added to PDF on page ${totalPages} at position:`, x, y);
                    getBlobAndResolve();
                } catch (error) {
                    console.error("Error adding QR code to PDF:", error);
                    getBlobAndResolve();
                }
            };

            img.onerror = (error) => {
                console.error("QR Code image couldn't be loaded from:", qrCodeUrl, error);
                getBlobAndResolve();
            };
        } else {
            console.log('QR code not included - qr:', qr, 'qrCode:', qrCode);
            getBlobAndResolve();
        }
    });
};
